import React from "react";
import styled from "@emotion/styled";
import {SectionTitle} from "pages/homePage/userProfile/styles";
import {useTranslation} from "react-i18next";
import {IPredictionsHistory} from "modules/actions/leaderboards";
import {map} from "lodash";
import PickHistoryRow from "pages/homePage/userProfile/pickHistory/PickHistoryRow";

const Wrapper = styled.div`
	width: 100%;
	flex: auto;
	@media (max-width: 1100px) {
		order: 2;
	}
`;

const PickListContainer = styled.ul`
	padding-top: 8px;
`;

const NoResult = styled.li`
	display: flex;
	align-items: center;
	justify-content: center;
	background: linear-gradient(90deg, #42474d 0%, #282f38 100%);
	border-radius: 8px;
	padding: 12px;
	font-size: 20px;
	font-weight: 700;
`;
interface IProps {
	picksHistory: IPredictionsHistory[];
}

const PickList: React.FC<IProps> = ({picksHistory}) => {
	const i18n = useTranslation();

	return (
		<Wrapper>
			<SectionTitle>{i18n.t("user_profile.picks.title", "Current Picks")}</SectionTitle>

			<PickListContainer>
				{picksHistory.length ? (
					map(picksHistory, (pick) => {
						return (
							<li key={pick.roundId} aria-labelledby={`${pick.roundId}-title-picks`}>
								<PickHistoryRow pick={pick} />
							</li>
						);
					})
				) : (
					<NoResult>{i18n.t("user_profile.picks.no_picks", "No Picks")}</NoResult>
				)}
			</PickListContainer>
		</Wrapper>
	);
};

export default PickList;
